var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Lottie',_vm._b({staticClass:"AnimatedNumbershapeLottie",style:({ '--color': _vm.color }),on:{"animCreated":_vm.handleAnimation}},'Lottie',_vm.lottieProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }